import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, useParams } from 'react-router-dom';
import { ProjectId, SpaceId } from 'api/models';
import { Loading } from 'components/atoms/loading';
import { Spaces } from 'components/organisms/spaces';
import { setActiveTabKey } from 'data/space-tabs';
import { useSpaceTabs } from 'data/space-tabs/hooks';
import { useSpace } from 'data/spaces/hooks';
import { useProjectSpacePermission } from 'hooks/permissions';
import { getSpaceDetailUrl } from 'utils/urls';

interface ParamTypes {
  projectId: string;
  spaceId: string;
  spaceTabId: string;
}

export const SpaceTabsPage: FC = () => {
  const params = useParams<ParamTypes>();
  const { spaceTabId } = params;
  const spaceId = Number(params.spaceId);
  const projectId = Number(params.projectId);
  const { data: spaceDetail, isLoading } = useSpace(spaceId);
  const data = useSpaceTabs(spaceId);

  const { canCreate } = useProjectSpacePermission(ProjectId(projectId));

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(setActiveTabKey(spaceTabId));
  }, [dispatch, spaceTabId]);

  if (isLoading) {
    return <Loading />;
  }

  if (
    (spaceDetail &&
      spaceDetail.spaceTabs.find((s) => s.spaceTabId === Number(spaceTabId))) ||
    (spaceTabId === 'new' && canCreate)
  ) {
    return <Spaces data={data} activeTabKey={spaceTabId} />;
  }

  return (
    <Redirect
      to={{
        pathname: getSpaceDetailUrl(SpaceId(projectId, spaceId)),
      }}
    />
  );
};
